export const removeSpaces = (value: string): string => {
  return value.replace(/ /g, '');
};
